module.exports = __webpack_public_path__ + "img/michael.b6f622f9.png";